import React from 'react';
import { Loader2 } from 'lucide-react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline' | 'ghost' | 'danger';
  size?: 'sm' | 'md' | 'lg' | 'xl';
  isLoading?: boolean;
  fullWidth?: boolean;
  icon?: React.ReactNode;
}
export function Button({
  children,
  className = '',
  variant = 'primary',
  size = 'md',
  isLoading = false,
  fullWidth = false,
  icon,
  disabled,
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center rounded-xl font-bold transition-all focus:outline-none focus:ring-4 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed active:scale-95';
  const variants = {
    primary: 'bg-red-600 text-white hover:bg-red-700 focus:ring-red-200 shadow-lg shadow-red-200',
    secondary: 'bg-blue-600 text-white hover:bg-blue-700 focus:ring-blue-200 shadow-lg shadow-blue-200',
    outline: 'border-2 border-slate-200 bg-white text-slate-700 hover:bg-slate-50 focus:ring-slate-200',
    ghost: 'bg-transparent text-slate-600 hover:bg-slate-100 focus:ring-slate-200',
    danger: 'bg-red-100 text-red-700 hover:bg-red-200 focus:ring-red-100'
  };
  const sizes = {
    sm: 'h-9 px-3 text-sm',
    md: 'h-12 px-6 text-base',
    lg: 'h-14 px-8 text-lg',
    xl: 'h-16 px-10 text-xl' // Extra large for main actions
  };
  const width = fullWidth ? 'w-full' : '';
  return <button className={`${baseStyles} ${variants[variant]} ${sizes[size]} ${width} ${className}`} disabled={disabled || isLoading} {...props} data-id="element-142">
      {isLoading ? <Loader2 className="mr-2 h-5 w-5 animate-spin" data-id="element-143" /> : icon ? <span className="mr-2" data-id="element-144">{icon}</span> : null}
      {children}
    </button>;
}